<template>
	<div class="bigbox">
		<div class="header">
			<h3 class="msstitle">設定</h3>
			<span @click="close" class="close">
				<i class="el-icon-close"></i>
			</span>
		</div>
		<div class="setbox">
			<ul>
				<li @click="clickopenmsg"><span class="messige_ico"><i class="el-icon-message"></i></span><span>查看所有通知</span></li>
			</ul>
		</div>
		<allmessage  v-if="openallmsg" @closemsgcenter="closemsgcenter" @closeallmessage="closeallmessage"></allmessage>
	</div>
</template>

<script>
	import allmessage from "./AllMessage.vue";
	export default {
		components: {
			allmessage,
			
		},
		data() {
			return {
				openallmsg:false
				
			}
		},
		
		methods: {
			clickopenmsg(){
				this.openallmsg =true;
			},
			closemsgcenter(){
				this.$emit('closemsgcenter', false);
			},
			closeallmessage(){
				this.openallmsg =false;
			},
			close(){
				this.$emit('closemsgcenter', false);
			}


		},
		created() {
			
		}
	}
</script>

<style scoped>
	.close {
		border-radius: 50%;
		font-size: 18px;
		width: 25px;
		height: 25px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #3399ff;
		color: #fff;
	}
	
	.header {
		padding: 15px;
		display: flex;
		justify-content: space-between;
		position: relative;
		border-bottom: 1px solid #e2e2e2;
	}
	.setbox{ padding: 15px;}
	.setbox li{ height: 40px; line-height: 40px; display: flex; align-items: center; justify-content: space-between; font-size: 14px;}
	.messige_ico{ font-size: 20px;}
	.bigbox{ position: relative;}
	
</style>
